import {injectable} from "inversify";
import { IFetchListArgs, IPagedData } from "../../stores/abstract-paged-data-store";
import {TYPE, rootContainer} from '../container/root';
import {IApiResponse, IHttpService} from "../http-service";
import {IUser} from "../../models/User";


export interface IUserMasterListData {
	paginator: IPagedData<IUser>;
	users: IUser[];
}
export interface userMaserListSearchParams {
	searchUserType:string;
	searchValue:string;
}

export interface loginResponse{
	success:boolean;
}

export interface ILoginRole {
	id: number;
	name: string;
	display_name: string;
}


@injectable()
export default class UserMasterListService {
	private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);
	
	async fetchList(searchOptions:userMaserListSearchParams, paginationOptions:IFetchListArgs): Promise<IPagedData<IUser>> {
		const res = await this.httpService.get<IApiResponse<IPagedData<IUser>>>(`/rms-api/user-master-list`,{...searchOptions,...paginationOptions});
		return res.payload;
	}

	async login(id:number, roleId: number, reason?: string) {
		const res = await this.httpService.post<IApiResponse<loginResponse>>(`/rms-api/user-master-list/loginAs`,{
            id,
            role_id: roleId,
            reason,
        });
		return res.payload;
	}

    async fetchListByIds(userIds: Array<number>) {
        const res = await this.httpService.post<IApiResponse<IUser[]>>(`/rms-api/user-master-list-get-by-ids`, {userIds});
        return res.payload;
    }

    async fetchLoginRoles(): Promise<ILoginRole[]> {
        const res = await this.httpService.get<IApiResponse<ILoginRole[]>>(`/rms-api/user-master-list/login-roles`);
        return res.payload;
    }
}